import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import SesssionDetail from "./SessionDetail";
import { getSessionsDetails } from "../../sagas/sessionDetail";

function mapState(state: any) {
  return {
    userType: state.login.userType,
    email: state.login.emailAddress,
    sessionDetailData: state.sessionDetail.data,
    sessionDetailsLoading: state.sessionDetail.loading,
    vitals: state.sessionDetail.vitals
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    fetchSessionDetails: bindActionCreators(getSessionsDetails, dispatch)
  };
}

export default connect(
  mapState,
  mapDispatchToProps
)(SesssionDetail);
